const daily_atwRouter = [
  {
      path: "daily-atw",
      name: "daily_atw",
      component: () => import("@/views/admin/daily_atw"),
      default: true,
      meta: {
          model: "daily_atw",
          // requiresAuth: true,
      },
  },
  {
      path: "daily-atw/add",
      name: "addDailyAtw",
      component: () => import("@/views/admin/daily_atw/function"),
      default: true,
      meta: {
          model: "daily_atw",
          // requiresAuth: true,
      },
  },
  {
      path: "daily-atw/edit/:id",
      name: "editDailyAtw",
      component: () => import("@/views/admin/daily_atw/function"),
      default: true,
      meta: {
          model: "daily_atw",
          // requiresAuth: true,
      },
  },
  {
    path: "daily-atw/view/:id",
    name: "detailDailyAtw",
    component: () => import("@/views/admin/daily_atw/view"),
    default: true,
    meta: {
        model: "daily_atw",
        // requiresAuth: true,
    },
  },
  {
    path: "daily-atw/detail/:id",
    name: "detailDailyAtw",
    component: () => import("@/views/admin/daily_atw/detail"),
    default: true,
    meta: {
        model: "daily_atw",
        // requiresAuth: true,
    },
  },
]
export default daily_atwRouter;